module.exports = "<router-outlet></router-outlet>";


//////////////////
// WEBPACK FOOTER
// ./Scripts/fw/content/content.component.html
// module id = 1855
// module chunks = 1